import { init } from '@sentry/react';
import { BrowserTracing } from '@sentry/browser';

const initSentry = config => {
    if (config.environment !== 'production') {
        return null;
    }

    init({
        dsn: 'https://f2273b83da9a4eb2bd1517f59bdc887f@o1159603.ingest.sentry.io/6698016',
        environment: config.environment || 'staging',
        integrations: [
            new BrowserTracing()
        ],
        beforeSend(event, hint) {
            const isNonErrorException =
                event.exception.values[0].value.startsWith('Non-Error exception captured') ||
                hint.originalException?.['message']?.startsWith('Non-Error exception captured');

            if (isNonErrorException) {
                return null;
            }

            return event;
        },
        tracesSampleRate: 0.1
    });
};


export {
    initSentry
}
